const handleScroll = (e, targetId, navigate, isOpenMenu, toggleMenu, setIsScrolling) => {
    e.preventDefault();

    navigate('/');

    setTimeout(() => {
        const targetElement = document.getElementById(targetId);

        if (targetElement) {
            let sectionPaddingTop = 0;

            if (targetId === 'about' || targetId === 'contact') {
                sectionPaddingTop = 20;
            }

            const navbarHeight = document.querySelector('nav').offsetHeight;
            const computedPaddingTop = parseInt(window.getComputedStyle(targetElement).paddingTop) || 0;
            const targetPosition = targetElement.getBoundingClientRect().top + window.scrollY - navbarHeight - computedPaddingTop + sectionPaddingTop;

            setIsScrolling(true);

            window.scrollTo({
                top: targetPosition,
                behavior: 'smooth',
            });

            const observer = new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        setTimeout(() => {
                            setIsScrolling(false);
                        }, 200);
                        observer.disconnect();
                    }
                });
            }, {
                root: null,
                threshold: 0.0
            });

            observer.observe(targetElement);

            if (isOpenMenu) {
                toggleMenu();
            }
        }
    }, 100);
};

export default handleScroll;
